var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveningMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9628 14.9556C20.1442 14.5236 19.6259 14.1556 19.1913 14.3476C18.3223 14.7286 17.3836 14.9247 16.4348 14.9236C12.7148 14.9236 9.69961 11.9689 9.69961 8.32359C9.69923 7.09293 10.0488 5.88754 10.7076 4.84805C10.9601 4.44983 10.657 3.89872 10.1947 4.01605C6.63114 4.92538 4 8.10048 4 11.8774C4 16.3636 7.71115 20 12.2899 20C15.7566 20 18.7255 17.9156 19.9628 14.9556Z",
    fill: "#90E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8679 4.0979C14.3631 3.76074 13.7612 4.36268 14.0974 4.86748L14.6974 5.76754C14.9411 6.13239 15.0711 6.56127 15.0711 7C15.0711 7.43873 14.9411 7.86761 14.6974 8.23246L14.0974 9.13252C13.7612 9.63732 14.3641 10.2393 14.8688 9.90209L15.7679 9.30206C16.1327 9.0584 16.5615 8.92836 17.0002 8.92836C17.4389 8.92836 17.8678 9.0584 18.2326 9.30206L19.1326 9.90209C19.6373 10.2393 20.2392 9.63732 19.9021 9.13252L19.3021 8.23246C19.0585 7.86761 18.9284 7.43873 18.9284 7C18.9284 6.56127 19.0585 6.13239 19.3021 5.76754L19.9021 4.86748C20.2392 4.36268 19.6373 3.76074 19.1316 4.0979L18.2326 4.69794C17.8678 4.9416 17.4389 5.07164 17.0002 5.07164C16.5615 5.07164 16.1327 4.9416 15.7679 4.69794L14.8679 4.0979Z",
    fill: "#90E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveningMoon);
export default __webpack_public_path__ + "static/media/evening_moon.5b135ee5476ad280aa872efd09423398.svg";
export { ForwardRef as ReactComponent };